<app-header></app-header>
<div class="container my-3  col-md-7 col-lg-6"> 
    <router-outlet></router-outlet>
</div>
<app-footer class="mt-auto"></app-footer>

